module.exports = __webpack_public_path__ + "img/kongtiao.ad6375ea.png";